/**
 * Asset path configuration
 * Matches the base path in vite.config.ts
 */

// Check if running in Capacitor (native app)
const isCapacitor = !!(window as any).Capacitor

// Base path for web deployment (matches vite.config.ts base setting)
// For Capacitor, assets are bundled locally, so no base path needed
export const BASE_PATH = isCapacitor ? '' : '/game/'

/**
 * Get the full path for an asset
 * @param assetPath - Relative path from the assets directory (e.g., 'board/default-bg.png')
 * @returns Full path including base path
 */
export function getAssetPath(assetPath: string): string {
    // Remove leading slash if present
    const cleanPath = assetPath.startsWith('/') ? assetPath.slice(1) : assetPath
    return `${BASE_PATH}${cleanPath}`
}
